import { isIraWithdrawalEligible } from '@ally/transfer-account-utils';
export var getIsIraWithdrawal = function (fromAccount, toAccount) {
    if (!fromAccount || !toAccount)
        return false;
    return isIraWithdrawalEligible(fromAccount);
};
//# sourceMappingURL=getIsIraWithdrawal.js.map